import { memo } from 'react';
import BannersLink from '@components/BannersLink';
import LoadingSkeleton from '@components/LoadingSkeleton';
import { Picture } from '@ui';
import './MenuItem.scss';

export const FloatTitle = ({ title, floatObj }) => (
  <div className='menu-item__title'>
    {title.slice(0, title.indexOf(floatObj.wholePart))} {floatObj.wholePart},
    <span className='menu-item__title__float-part'>{floatObj.floatPart}₽</span>
  </div>
);

export const MenuItemLoading = () => (
  <div className='banners-link menu-item flex gap-[8px]'>
    <LoadingSkeleton className='w-[20px] h-[20px] !rounded-full' />
    <LoadingSkeleton className='h-[1lh] w-[100px]' />
  </div>
);

const MenuItem = ({ isRed, isLast, icon, title, link }) => (
  <BannersLink
    className={`menu-item${isLast ? ' menu-item--last' : ''}${
      isRed ? ' menu-item--red' : ''
    }`}
    link={link}
  >
    <div className='menu-item__wrapper'>
      <Picture
        pictureClassName='menu-item__icon'
        height='20'
        width='20'
        icon={icon}
      />
    </div>
    {title}
  </BannersLink>
);

export default memo(MenuItem);
